module.exports = __webpack_public_path__ + "img/5681b71.jpg";